import { useRef } from "react";

import type { OverlayOptions } from "../index.ts";
import { useDialog } from "./useDialog.ts";

export interface ControlledDialog {
  onCancel?: () => void;
}

/** @deprecated use Modal or PopOver with useOverlay */
export const useControlledDialog = (onCancel?: () => void, options?: Omit<OverlayOptions, "placement">) => {
  const dialogRef = useRef<HTMLDivElement>(null);
  const { dialogProps, state, underlayProps } = useDialog(
    {
      ...options,
      isOpen: true,
      onOpenChange(isOpen) {
        if (!isOpen) {
          // close on "Escape", ...
          onCancel?.();
        }
      },
    },
    dialogRef,
  );

  return { dialogRef, dialogProps, state, underlayProps };
};
